<template>
  <div>
    <div
      v-if="school.type !== 'class' && !school.hidden"
      :class="['SchoolHQSelector__SchoolHQSelectItem', 'min-h-32px py-6px px-16px hover:bg-white whitespace-normal']"
      @click="onSelect(school)"
    >
      <div
        :class="[
          {
            'pl-24px': level === 1,
            'pl-48px': level === 2,
            'pl-72px': level === 3,
          },
          'leading-5 relative',
        ]"
      >
        <div
          v-if="level > 0"
          :class="[
            {
              'left-[-6px]': level === 1,
              'left-[18px]': level === 2,
              'left-[42px]': level === 3,
            },
            'absolute top-0px flex items-center w-24px h-24px justify-center',
          ]"
        >
          <span class="w-6px h-6px rounded-3 bg-regular-grey block"></span>
        </div>
        {{ school.name }}
      </div>
    </div>
    <template v-if="hasChildren">
      <SchoolHQSelectItem
        v-for="item in school.children"
        :key="item.id"
        :school="item"
        :searchText="searchText"
        :parentSchool="school"
        :onSelect="onSelect"
        :level="level + 1"
      ></SchoolHQSelectItem>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { every } from 'lodash'

Vue.filter('highlightText', (words, searchText) => {
  const query = new RegExp(searchText, 'g')
  const result = words.toString().replace(query, (matchedTxt) => {
    return `<span class='text-highlight'>${matchedTxt}</span>`
  })
  return result
})

export default {
  name: 'SchoolHQSelectItem',

  props: {
    school: {
      type: Object,
      default: () => {},
    },
    parentSchool: {
      type: Object,
      default: () => {},
    },
    searchText: {
      type: String,
      default: () => '',
    },
    onSelect: {
      type: Function,
      default: () => {},
    },
    level: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    isTopLevel() {
      return ['hq', 'cluster', 'branch'].includes(this.school.type)
    },
    hasChildren() {
      return (
        this.school.children &&
        this.school.children.length > 0 &&
        every(this.school.children, (children) => {
          return children.type !== 'class'
        })
      )
    },
  },
}
</script>

<style lang="scss"></style>
